const SALON_FLAG = Object.freeze({
  //
  // These are regular flags, for different things
  //
  clientTags: 'client tags',
  timeOffCats: 'timeoff_categories',
  emailMarketing: 'email_marketing',
  smsPricing: 'old_sms_pricing',
  forms: 'forms',
  useNewNcob: 'use_new_ncob',

  //
  // These are the checkout and payment flags
  //
  auditCheckoutToSentry: 'audit_checkout_to_sentry',
  multiplePosReadersDialog: 'multiple_readers_dialog',

  //
  // These are old flags for the checkCapFlag prefix, should be considered deprecated
  // SEE: src/bl/salon/checkCapFlag.bl.js
  //
  beInitReaderPayment: 'beInitReaderPayment.action',
  determineAndStorePaymentIntentId: 'determinePaymentIntent.bl',
  PayPopUp: 'PayPopUp.component',
  PosReaderDialog: 'PosReaderDialog.component',

  //
  // These are meant for temporary use while development/testing on staging, not production
  //
  tmpPosShowPriceLines: 'show pos price lines',
  tmpPosManualSteps: 'manual pos steps',
  tmpPaymentArrival: 'payment arrival',
});

export default SALON_FLAG;
